export default [{
	prop: 'restaurantName',
	label: '订货企业',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'fromOrganName',
	label: '订货机构',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'toOrganName',
	label: '收货机构',
	width: '180',
	ischoose: true,
	align: 'center'
},  {
	prop: 'billType',
	label: '单据类型',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'fromDate',
	label: '开始日期',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'toDate',
	label: '结束日期',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'goodsCode',
	label: '品项编码',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'goodsName',
	label: '品项名称',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'goodsSpec',
	label: '品项规格',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'goodsUnit',
	label: '品项单位',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'goodsNumSend',
	label: '数量',
	width: '120',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'goodsNum',
	label: '订货数量',
	width: '120',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'remainNumSend',
	label: '待发数量',
	width: '180',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'subTotalSend',
	label: '含税金额',
	width: '120',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'subTotalRecipient',
	label: '实收金额',
	width: '180',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'goodsNumRecipient',
	label: '实收数量',
	width: '180',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'goodsPriceSend',
	label: '单价',
	width: '180',
	headerAlign: 'center',
	ischoose: false,
	align: 'right'
}]
